// Tool Widget Registry
// Each tool can register a widget component that renders its results

import type { ComponentType } from "react";
import { SearchEnseignesWidget } from "./search-enseignes";
import { SearchCandidatsWidget } from "./search-candidats";
import { SearchVillesWidget } from "./search-villes";
import { SearchLocationsWidget } from "./search-locations";
import { SearchDocumentsWidget } from "./search-documents";
import { FoursquarePlacesWidget } from "./foursquare-places";
import { FoursquareDetailsWidget } from "./foursquare-details";
import { FoursquareCategoriesWidget } from "./foursquare-categories";
import { GooglePlacesSearchWidget } from "./google-places-search";
import { GooglePlacesDetailsWidget } from "./google-places-details";

export interface ToolWidgetProps<T = unknown> {
  data: T;
  count?: number;
}

// Widget registry - map tool names to their display components
// Keys must match component_key from backend (underscored format)
const widgetRegistry: Record<
  string,
  ComponentType<ToolWidgetProps<unknown>>
> = {
  search_enseignes: SearchEnseignesWidget as ComponentType<ToolWidgetProps<unknown>>,
  search_candidats: SearchCandidatsWidget as ComponentType<ToolWidgetProps<unknown>>,
  search_villes: SearchVillesWidget as ComponentType<ToolWidgetProps<unknown>>,
  search_locations: SearchLocationsWidget as ComponentType<ToolWidgetProps<unknown>>,
  search_documents: SearchDocumentsWidget as ComponentType<ToolWidgetProps<unknown>>,
  foursquare_places: FoursquarePlacesWidget as ComponentType<ToolWidgetProps<unknown>>,
  foursquare_details: FoursquareDetailsWidget as ComponentType<ToolWidgetProps<unknown>>,
  foursquare_categories: FoursquareCategoriesWidget as ComponentType<ToolWidgetProps<unknown>>,
  google_places_search: GooglePlacesSearchWidget as ComponentType<ToolWidgetProps<unknown>>,
  google_places_details: GooglePlacesDetailsWidget as ComponentType<ToolWidgetProps<unknown>>,
};

export function getWidget(
  toolName: string
): ComponentType<ToolWidgetProps<unknown>> | null {
  return widgetRegistry[toolName] || null;
}
